import styled from "styled-components";
import { COLORS } from "~/src/styles/config.style";

export const Text = styled.p`
  color: ${COLORS.COOL_GREY};
`;
